// Classes.
import {BaseLocator} from './../locators/base.locator';


export class WCupSeasonLocator extends BaseLocator {

  constructor() {
    super('wCupSeason');
  }
}

